var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.667 4.813L4.402 6.667H2v2.666h2.402l2.265 1.854V4.813zm-2.74 5.853H1.332A.667.667 0 01.667 10V6a.667.667 0 01.666-.667h2.593l3.53-2.888A.333.333 0 018 2.703v10.594a.333.333 0 01-.545.258l-3.528-2.889zm9.01 2.756l-.944-.944A5.985 5.985 0 0014 8a5.988 5.988 0 00-2.203-4.645l.947-.947A7.317 7.317 0 0115.334 8a7.315 7.315 0 01-2.397 5.422zm-2.362-2.362l-.948-.947A2.663 2.663 0 0010.667 8c0-.953-.5-1.79-1.254-2.261l.96-.96A3.994 3.994 0 0112 8a3.991 3.991 0 01-1.425 3.061z",
    fill: "#58657C"
  })));
}
export default SvgNotice;